import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type BaseButtonColor = 'grey' | 'red' | 'green' | 'mint' | 'blue' | 'transparent' | 'transparent-gray' | 'transparent-red';
interface Props {
    color?: BaseButtonColor;
    isDisabled?: boolean;
    isSmall?: boolean;
    isXSmall?: boolean;
    isNoShadow?: boolean;
    isWithIcon?: boolean;
    isOnlyIcon?: boolean;
    isXSmallOnMobile?: boolean;
    isSmallOnMobile?: boolean;
    isNowrap?: boolean;
    isBorderless?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    color: null,
    isDisabled: { type: Boolean },
    isSmall: { type: Boolean },
    isXSmall: { type: Boolean },
    isNoShadow: { type: Boolean },
    isWithIcon: { type: Boolean },
    isOnlyIcon: { type: Boolean },
    isXSmallOnMobile: { type: Boolean },
    isSmallOnMobile: { type: Boolean },
    isNowrap: { type: Boolean },
    isBorderless: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
    color?: BaseButtonColor;
    isDisabled?: boolean;
    isSmall?: boolean;
    isXSmall?: boolean;
    isNoShadow?: boolean;
    isWithIcon?: boolean;
    isOnlyIcon?: boolean;
    isXSmallOnMobile?: boolean;
    isSmallOnMobile?: boolean;
    isNowrap?: boolean;
    isBorderless?: boolean;
}




const getClasses = computed(() => {
    const classes = {
        '--small': props.isSmall,
        '--x-small': props.isXSmall,
        '--no-shadow': props.isNoShadow,
        '--disabled': props.isDisabled,
        '--with-icon': props.isWithIcon,
        '--only-icon': props.isOnlyIcon,
        '--small-on-mobile': props.isSmallOnMobile,
        '--x-small-on-mobile': props.isXSmallOnMobile,
        '--nowrap': props.isNowrap,
        '--borderless': props.isBorderless,
        [`--${props.color}`]: !!props.color,
    };
    return Object.keys(classes).filter((key) => classes[key]).join(' ');
});

const click = () => {
    if (props.isDisabled) return;
    emit('click');
};


return { __sfc: true,props, emit, getClasses, click }
}

})